export const LOCAL_STORAGE_KEYS = {
  DISMISSED_PLATFORM_BANNERS: 'dismissedPlatformBanners',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  GUEST_LOCALE: 'guest_locale',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  CAPTAIN_OVERVIEW_V2: 'captain_overview_v2',
  SIDEBAR_MINIMIZED_SECTIONS: 'sidebarMinimizedSections',
};
